export default __webpack_public_path__ + "static/media/warning.97fc2c7a.svg";